// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Gestione",
  tabRestricted: "Il mio rendiconto",
  restrictedTitle: "Il mio rendiconto",

  pageFilters: {
    ownership: "Alloggi",
    ownershipAll: "Gestiti e propri",
    ownershipManaged: "Solo gestiti",
    ownershipOwn: "Solo propri",
    owner: "Proprietario",
    allOwners: "Tutti i proprietari",
  },

  views: {
    business: "La mia attività",
    owners: "Proprietari",
    expenses: "Spese",
  },

  filters: {
    listings: "Alloggi",
    allListings: "Tutti",
    someListings: "{count} alloggi",
    owner: "Proprietario",
    allOwners: "Tutti",
    attribution: "Conta le prenotazioni per",
    checkout: "Data di check-out",
    checkin: "Data di check-in",
    nights: "Notti del periodo",
    attributionHelp: "Per check-out è come si fa il rendiconto ai proprietari: il soggiorno è già concluso.",
    attributionHelpLabel: "Cosa significa «Conta le prenotazioni per»",
    currency: "Valuta",
  },

  warnings: {
    otaEstimated:
      "{count} prenotazione con la commissione OTA stimata in percentuale: il canale non ha comunicato quella reale. | {count} prenotazioni con la commissione OTA stimata in percentuale: il canale non ha comunicato quella reale.",
    noBreakdown:
      "{count} prenotazione senza dettaglio: tutto l'importo è stato considerato alloggio. | {count} prenotazioni senza dettaglio: tutto l'importo è stato considerato alloggio.",
    outdatedBreakdown:
      "{count} prenotazione è stata modificata o prolungata dopo l'importazione: è stato usato il suo importo attuale. | {count} prenotazioni sono state modificate o prolungate dopo l'importazione: è stato usato il loro importo attuale.",
    otherCurrencies: "Ci sono alloggi in un'altra valuta ({currencies}). Cambiala qui sopra per vederli.",
    noOwner:
      "{count} alloggio gestito non ha un proprietario assegnato. | {count} alloggi gestiti non hanno un proprietario assegnato.",
    assignOwners: "Assegna proprietari",
  },

  states: {
    loadError: "Impossibile caricare i dati di gestione.",
    forbidden: "Non hai i permessi per vedere queste informazioni.",
    periodTooLong: "Scegli un periodo di massimo due anni.",
    retry: "Riprova",
    noMovements: "Nessun movimento in questo periodo",
  },

  empty: {
    title: "Gestisci alloggi di altri proprietari?",
    text: "Indica in ogni alloggio che lo gestisci per conto di un proprietario e a quali condizioni: la tua commissione, chi incassa le prenotazioni e come vengono gestite le pulizie. Qui vedrai quanto guadagni tu e quanto spetta a ciascun proprietario.",
    point1: "Le tue commissioni, pulizie e spese, con il tuo utile reale",
    point2: "Quanto trasferire o addebitare a ciascun proprietario",
    point3: "Il rendiconto di ogni proprietario in PDF o Excel",
    cta: "Configura i miei alloggi",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "prenotazioni per data di check-out",
    byCheckin: "prenotazioni per data di check-in",
    byNights: "notti del periodo",
    day: "per giorno",
    week: "per settimana",
    month: "per mese",
  },

  counts: {
    reservations: "{count} prenotazione | {count} prenotazioni",
    nights: "{count} notte | {count} notti",
    units: "{count} alloggio | {count} alloggi",
    ownUnits: "{count} alloggio proprio | {count} alloggi propri",
    owners: "{count} proprietario | {count} proprietari",
  },

  business: {
    kpi: {
      managedGross: "Fatturato gestito",
      commissions: "Le tue commissioni",
      cleaning: "Pulizie",
      ownRevenue: "Ricavi degli alloggi propri",
      expenses: "Spese",
      profit: "Utile",
    },
    vatLine: "+ IVA {amount}",
    ofTotal: "del fatturato totale",
    overManaged: "sul fatturato gestito",
    ofIncome: "delle tue entrate",
    margin: "di margine",
    chartTitle: "Entrate, spese e utile",
    chartA11y: "Grafico delle entrate, delle spese e dell'utile del periodo",
    legend: {
      commissions: "Commissioni",
      cleaning: "Pulizie",
      own: "Alloggi propri",
      expenses: "Spese",
      profit: "Utile",
    },
    byCategory: "Spese per categoria",
    category: "Categoria",
    amount: "Importo",
    noExpenses: "Nessuna spesa in questo periodo",
    seeExpenses: "Vedi spese",
  },

  owners: {
    kpi: {
      gross: "Ricavi da prenotazioni",
      ota: "Commissioni OTA",
      cleaning: "Pulizie",
      commission: "La tua commissione + IVA",
      commissionRestricted: "Commissione del gestore + IVA",
      charged: "Spese riaddebitate",
      net: "Netto ai proprietari",
      netRestricted: "Il tuo netto",
    },
    ofGross: "dei ricavi",
    collectedByYou: "lo incassi tu",
    collectedByManager: "lo incassa il tuo gestore",
    commissionLine: "{commission} + IVA {vat}",
    otaLine: "{commission} + IVA {vat}",
    otaTitle: "Commissione OTA {commission} + IVA {vat}",
    commissionTitle: "Commissione {commission} + IVA {vat}",
    toTransfer: "Da trasferire ai proprietari",
    toCollect: "Da incassare dai proprietari",
    toTransferRestricted: "Il tuo gestore ti trasferisce",
    toCollectRestricted: "Da pagare al tuo gestore",
    chartTitle: "Ripartizione degli incassi",
    chartA11y: "Grafico della ripartizione dei ricavi delle prenotazioni gestite",
    legend: {
      net: "Netto proprietari",
      netRestricted: "Il tuo netto",
      commissions: "Le tue commissioni",
      commissionsRestricted: "Commissione del gestore",
      ota: "Commissioni OTA",
      cleaning: "Pulizie",
      other: "Tasse, cauzioni, IVA e spese",
    },
    grossFooter: "Ricavi: {amount}",
    tableTitle: "Rendiconto per proprietario",
    tableTitleRestricted: "Dettaglio del tuo rendiconto",
    downloadAll: "Scarica tutto (PDF)",
    download: "Scarica (PDF)",
    downloading: "Download in corso…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "Impossibile scaricare il rendiconto.",
    cols: {
      owner: "Proprietario",
      reservations: "Prenotazioni",
      gross: "Ricavi",
      ota: "OTA",
      cleaning: "Pulizie",
      commission: "Commissione + IVA",
      charged: "Spese",
      net: "Netto",
      balance: "Saldo",
      actions: "Download",
    },
    noOwner: "Senza proprietario assegnato",
    transfer: "Da trasferire {amount}",
    collect: "Da incassare {amount}",
    receive: "Da ricevere {amount}",
    pay: "Da pagare {amount}",
    collectionManager: "Incassa il gestore",
    collectionOwner: "Incassa il proprietario",
    total: "Totale",
    expand: "Mostra il dettaglio di {name}",
    collapse: "Nascondi il dettaglio di {name}",
    iban: "IBAN {iban}",
    showReservations: "Vedi prenotazioni ({count})",
    hideReservations: "Nascondi prenotazioni",
    noData: "Nessuna prenotazione gestita in questo periodo.",
    reservations: {
      checkIn: "Arrivo",
      checkOut: "Partenza",
      guest: "Ospite",
      listing: "Alloggio",
      channel: "Canale",
      gross: "Ricavi",
      ota: "OTA",
      cleaning: "Pulizie",
      commission: "Commissione",
      vat: "IVA",
      net: "Netto",
      direct: "Diretta",
      estimated: "stim.",
      estimatedHelp: "Stimata in percentuale: il canale non ha comunicato la commissione reale.",
      noBreakdown: "senza dettaglio",
      noBreakdownHelp: "La prenotazione non ha il dettaglio: tutto l'importo è stato considerato alloggio.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Caricamento delle prenotazioni…",
      loadError: "Impossibile caricare le prenotazioni.",
      empty: "Nessuna prenotazione in questo periodo.",
    },
    charged: {
      title: "Spese riaddebitate al proprietario",
      date: "Data",
      concept: "Descrizione",
      listing: "Alloggio",
      amount: "Importo",
      general: "Generale",
    },
  },

  a11y: {
    views: "Sezioni di gestione",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Prezzo",
    comision: "Commissione OTA",
    tasas: "Tasse",
    limpieza: "Pulizia",
    honorarios: "Onorari",
    honorariosIva: "Onorari + IVA",
    neto: "Netto proprietario",
    transfieres: "Gli trasferisci",
    tePaga: "Ti paga",
    recibes: "Ricevi",
    pagas: "Paghi",
    netoPropietarios: "Netto per i proprietari",
    formula: "Incasso = Prezzo − Commissione · Totale = Incasso − Tasse − Pulizia · Netto = Totale − Onorari − IVA. Come nel PDF e nell'Excel.",
    cols: {
      origen: "Origine",
      nombre: "Nome",
      entrada: "Arrivo",
      salida: "Partenza",
      precio: "Prezzo",
      noches: "Notti",
      comision: "Commissione",
      ingreso: "Incasso",
      tasas: "Tasse",
      limpieza: "Pulizia",
      total: "Totale",
      honorarios: "Onorari",
      iva: "IVA",
      neto: "Netto",
    },
  },
};
